import { render, staticRenderFns } from "./CCloneDetails.vue?vue&type=template&id=63fbf8d2&lang=pug"
import script from "./CCloneDetails.vue?vue&type=script&lang=js"
export * from "./CCloneDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports